<template>
  <div>
    <p><button type="button" class="btn btn-primary mb-1" id="boton-nueva-familia">Nueva familia</button></p>

    Adscripción:
    <b-form-group>
      <b-form-radio-group
        id="adscripcion-grupo"
        v-model="adscripcionSeleccionado"
        :options="adscripcionOpciones"
        buttons
        button-variant="outline-secondary"
        name="adscripcion-grupo"
      ></b-form-radio-group>
    </b-form-group>

    Estado:
    <b-form-group>
      <b-form-radio-group
        id="estado-grupo"
        v-model="estadoSeleccionado"
        :options="estadoOpciones"
        buttons
        button-variant="outline-secondary"
        name="estado-grupo"
      ></b-form-radio-group>
    </b-form-group>

    Rol:
    <b-form-group>
      <b-form-radio-group
        id="rol-grupo"
        v-model="rolSeleccionado"
        :options="rolOpciones"
        buttons
        button-variant="outline-secondary"
        name="rol-grupo"
      ></b-form-radio-group>
    </b-form-group>

	<template v-if="niveles">
    Sección:
    <b-dropdown id="dropdown-seccion" :text="seccionTexto">
      <b-dropdown-item @click="seccionSeleccionada = null">Todas</b-dropdown-item>
      <b-dropdown-item v-for="(seccion, index) in obtenerSecciones()" :key="index" @click="seccionSeleccionada = seccion">{{ seccion }}</b-dropdown-item>
    </b-dropdown>

    Nivel:
    <b-dropdown id="dropdown-nivel" :text="nivelTexto">
      <b-dropdown-item @click="nivelSeleccionado = null">Todos</b-dropdown-item>
      <b-dropdown-item v-for="nivel in niveles" :key="nivel.id_nivel" @click="nivelSeleccionado = nivel">{{ nivel.nombre }}</b-dropdown-item>
    </b-dropdown>

    Clase:
    <b-dropdown id="dropdown-nivel" :text="claseTexto">
      <b-dropdown-item @click="claseSeleccionada = null">Todas</b-dropdown-item>
      <b-dropdown-item v-for="clase in obtenerNivelesClases()" :key="clase.codigo" @click="claseSeleccionada = clase">{{ clase.texto }}</b-dropdown-item>
    </b-dropdown>

    <div class="form-group row my-3">
      <label class="col-md-2 col-form-label" for="busqueda">Buscar</label>
      <div class="col-md-5">
      <input id="busqueda" name="busqueda" type="text" value="" class="form-control" v-model="busqueda" @keyup="actualizarBusqueda">
      </div>
    </div>

    <button type="button" class="btn btn-primary mb-3" @click="mostrarInfoContacto()">Mostrar email/teléfono</button>

	</template>

    <table v-if="familias" class="table table-striped table-bordered table-hover" id="tabla-personas">
      <thead>
        <tr>
          <th>Socio</th>
          <th>Nombre</th>
          <th>Apellidos</th>
          <th>Nivel</th>
          <th>adscripcion</th>
          <th>seccion</th>
          <th>id_nivel</th>
          <th>id_clase</th>
          <th>tipo_socio</th>
          <th>activos</th>
          <th>rol</th>
          <th>Teléfono&nbsp;1</th>
          <th>Teléfono&nbsp;2</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="f in familias">
        <tr v-for="p in f.miembros" :key="p.id" class="fila-familia" @click="abrirFamilia(f.id)" @click.middle="abrirFamiliaTab(f.id)">
          <td v-if="f.activos" class="text-success">{{ f.num_socio }}</td>
          <td v-else class="text-danger">{{ f.num_socio }}</td>
          <td>{{ p.nombre }}</td>
          <td>{{ p.apellidos }}</td>
          <td :data-sort="obtenerCodigoNivelClase(p.nivel.id_nivel, p.nivel.clase)">{{ obtenerNivelTexto(p.nivel) }}</td>
          <td>{{ f.adscripcion }}</td>
          <td>{{ obtenerSeccionNivel(p.nivel.id_nivel) }}</td>
          <td>{{ p.nivel.id_nivel }}</td>
          <td>{{ obtenerCodigoNivelClase(p.nivel.id_nivel, p.nivel.clase) }}</td>
          <td>{{ f.adscripcion }}</td>
          <td v-if="f.activos">activos</td>
          <td v-else>suspendidos</td>
          <td>{{ p.rol }}</td>
          <td>{{ p.telefono1 }}</td>
          <td>{{ p.telefono2 }}</td>
          <td>{{ p.email }}</td>
        </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

//import axios from 'axios';
//import { request, gql } from 'graphql-request';

import { api } from '../api/api.js';
import { obtenerCursoActivo } from '../curso.js';
import * as utils from '../utils.js';

import $ from 'jquery';
import 'pdfmake';
//import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
//require('../../../css/datatables.min.css')

export default {
	name: 'AdminFamilias',
	data () {
		return {
			dataTable: null,
			familias: null,
			curso: null,
			niveles: null,

			adscripcionSeleccionado: 'todos',
			adscripcionOpciones: [
				{ text: 'Todos', value: 'todos' },
				{ text: 'Socios', value: 'socios' },
				{ text: 'Exsocios', value: 'exsocios' },
				{ text: 'Ajenos', value: 'ajenos' },
			],

			estadoSeleccionado: 'todos',
			estadoOpciones: [
				{ text: 'Todos', value: 'todos' },
				{ text: 'Activos', value: 'activos' },
				{ text: 'Suspendidos', value: 'suspendidos' },
			],

			rolSeleccionado: 'todos',
			rolOpciones: [
				{ text: 'Todos', value: 'todos' },
				{ text: 'Titulares', value: 'titulares' },
				{ text: 'Contactos', value: 'contactos' },
				{ text: 'Beneficiarios', value: 'beneficiarios' },
			],

			seccionSeleccionada: null,
			seccionTexto: 'Todas',

			nivelSeleccionado: null,
			nivelTexto: 'Todos',

			claseSeleccionada: null,
			claseTexto: 'Todas',

			busqueda: '',
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		this.procesarNiveles(this.curso.niveles);
		this.obtenerPersonas();
	},
	watch: {
		//busqueda: function(val) {
		//	this.dataTable.search(val).draw();
		//},
		adscripcionSeleccionado: function(val) {
			const dt = this.dataTable;
			switch(val) {
				case 'todos':
					dt.column(8).search("").draw();
					break;
				case 'socios':
					dt.column(8).search("^socio$", true).draw();
					break;
				case 'exsocios':
					dt.column(8).search("^exsocio$", true).draw();
					break;
				case 'ajenos':
					dt.column(8).search("^ajeno$", true).draw();
					break;
			}
		},
		estadoSeleccionado: function(val) {
			const dt = this.dataTable;
			switch(val) {
				case 'todos':
					dt.column(9).search("").draw();
					break;
				case 'activos':
					dt.column(9).search("^activos$", true).draw();
					break;
				case 'suspendidos':
					dt.column(9).search("^suspendidos$", true).draw();
					break;
			}
		},
		rolSeleccionado: function(val) {
			const dt = this.dataTable;
			switch(val) {
				case 'todos':
					dt.column(10).search("").draw();
					break;
				case 'titulares':
					dt.column(10).search("^titular$", true).draw();
					break;
				case 'contactos':
					dt.column(10).search("^contacto$", true).draw();
					break;
				case 'beneficiarios':
					dt.column(10).search("^beneficiario$", true).draw();
					break;
			}
		},
		seccionSeleccionada: function(seccion) {
			const dt = this.dataTable;
			if (seccion) {
				this.seccionTexto = seccion;
				this.nivelSeleccionado = null;
				this.claseSeleccionada = null;
				dt.column(5).search("^" + seccion + "$", true).draw();
			} else {
				this.seccionTexto = 'Todas';
				dt.column(5).search("").draw();
			}
		},
		nivelSeleccionado: function(nivel) {
			const dt = this.dataTable;
			if (nivel) {
				this.nivelTexto = nivel.nombre;
				this.seccionSeleccionada = null;
				this.claseSeleccionada = null;
				dt.column(6).search("^" + nivel.id_nivel + "$", true).draw();
			} else {
				this.nivelTexto = 'Todos';
				dt.column(6).search("").draw();
			}
		},
		claseSeleccionada: function(clase) {
			const dt = this.dataTable;
			if (clase) {
				this.claseTexto = clase.texto;
				this.seccionSeleccionada = null;
				this.nivelSeleccionado = null;
				dt.column(7).search("^" + clase.codigo + "$", true).draw();
			} else {
				this.claseTexto = 'Todas';
				dt.column(7).search("").draw();
			}
		},
	},
	methods: {
		prepararTabla() {
			this.dataTable = $('#tabla-personas').DataTable({
				// Ordenar por apellidos + nombre
				//"order": [[2, "asc"], [1, "asc"]],
				// Ordenar por número de socio (será el orden por defecto, nos ahorramos volver a ordenarlo)
				//"order": [[0, "asc"]],
				"order": [],
				"pageLength": 100,
				"lengthMenu": [[ 50, 100, 200, -1 ], [50, 100, 200, 'Todos']],
				//"info": false,
				"columnDefs": [
					{
						"targets": [ 4, 5, 6, 7, 8, 9, 10, 11, 12, 13 ],
						"visible": false,
					},
					{
						"targets": [ 0, 1, 2, 4, 5, 6, 7, 8, 9, 10 ],
						"class": "noVis",
					}
				],
				"dom": "<'row'<'col-12 col-md-6'B><'col-12 col-md-6 text-right'l>>" +
						"<'row'<'col-12 col-md-6'i><'col-12 col-md-6'p>>" +
						"<'row'<'col-12'tr>>",
				"buttons": [
					{
						extend: 'csvHtml5',
						exportOptions: {
							columns: ':visible',
						}
					},
					{
						extend: 'excelHtml5',
						exportOptions: {
							columns: ':visible',
						}
					},
					{
						extend: 'pdfHtml5',
						exportOptions: {
							columns: ':visible',
						}
					},
					{
						extend: 'print',
						text: 'Imprimir',
						exportOptions: {
							columns: ':visible',
						}
					},
					//{
					//	extend: 'colvis',
					//	text: 'Escoger columnas',
					//	columns: ':not(.noVis)'
					//}
				],
				"language": {
					"lengthMenu": "_MENU_ filas",
					"info": "_TOTAL_ filas (mostrando _START_-_END_)",
					"infoEmpty": "0 filas",
					"infoFiltered": "", // _MAX_
					"zeroRecords": "No hay filas que mostrar",
					"emptyTable": "Sin datos en la tabla",
					"paginate": {
						"first": "&lt;&lt;",
						"previous": "&lt;",
						"next": "&gt;",
						"las": "&gt;&gt;",
					},
				},
			});
		},
		obtenerPersonas () {
			//api('/niveles')
			//	.then(res => {
			//		this.procesarNiveles(res);
			//	});
			
			api('/familias')
				.then(res => {
					this.familias = res.resultado;
					this.$nextTick(() => {
						this.prepararTabla();
					});
				});
		},
		abrirFamilia(id_familia) {
			this.$router.push('/admin/familia/' + id_familia);
		},
		abrirFamiliaTab(id_familia) {
			window.open('/admin/familia/' + id_familia);
		},
		actualizarBusqueda() {
			this.dataTable.search(this.busqueda).draw();
		},
		procesarNiveles(listaNiveles) {
			this.niveles = {};
			listaNiveles.forEach(n => {
				this.niveles[n.id_nivel] = n;
			});
		},
		obtenerSecciones() {
			const secciones = [];
			for (const id_nivel in this.niveles) {
				const seccion = this.niveles[id_nivel].seccion;
				if (!secciones.includes(seccion)) {
					secciones.push(seccion);
				}
			}
			return secciones;
		},
		obtenerNivelesClases() {
			var clases = [];
			for (var id_nivel in this.niveles) {
				if (this.niveles[id_nivel].clases) {
					this.niveles[id_nivel].clases.forEach(clase => {
						clases.push({
							texto: this.niveles[id_nivel].nombre + ' ' + clase,
							codigo: id_nivel + '/' + clase,
						});
					});
				} else {
					clases.push({
						texto: this.niveles[id_nivel].nombre,
						codigo: id_nivel + '/na',
					});
				}
			}
			return clases;
		},
		obtenerSeccionNivel(id_nivel) {
			return this.niveles[id_nivel].seccion;
		},
		obtenerCodigoNivelClase(id_nivel, clase) {
			if (!clase) {
				clase = 'na';
			}
			return id_nivel + '/' + clase;
		},
		obtenerNivelTexto(nivel) {
			return utils.convertirNivelClase(nivel);
		},
		mostrarInfoContacto() {
			this.dataTable.columns([11,12,13]).visible(true);
		}
	}

}
</script>
